import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';
import { summaryCardVars } from './SummaryCard.palette';

export const snapSummaryCardPrimaryVars: MotifComponentProps<MotifComponent.SUMMARY_CARD> = {
  ...summaryCardVars,
  '--summary-card-border-color': m('--fg-color'),
  '--summary-card-border-radius': '0px',
  '--summary-card-border-width': '1px',
  '--summary-card-box-shadow': 'none',
  '--summary-card-hover-border-color': m('--fg-color'),
};
